const getNewAccessToken = async () => {
    try {
        const response = await fetch('/api/users/refresh-token', {
            method: 'POST',
            credentials: 'include',
        });
        if (!response.ok) {
            throw new Error('Failed to refresh token');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error refreshing token:', error);
        throw error;
    }
};

module.exports = {
    getNewAccessToken,
};  